<!-- eslint-disable max-lines -->
<template>
    <el-dialog
        title="详情"
        :visible.sync="detailsShow"
        width="86%"
        class="sign-detail"
        :before-close="handleClose">
        <div slot="title">
            <div class="header-title">
                <span @click="handleChangeView('sign')" :class="currentView === 'sign' ? 'activeClass' : ''">{{titleName}}</span>
                <span v-if="totalData.isUser"
                    @click="handleChangeView('userSign')" :class="currentView === 'userSign' ? 'activeClass' : ''">用户签收详情</span>
                <span v-if="netDetailsIsShow()"
                 @click="handleChangeView('delivery')" :class="currentView === 'delivery' ? 'activeClass' : ''">网点配送详情</span>
            </div>
        </div>
        <div>
            <delivery-details :readOnly="readOnly" v-show="currentView === 'delivery'" :rowData="rowData"
                @handleClose="handleClose" @detailsClose="detailsClose" @refreshList="refreshList"></delivery-details>
            <sign-in-details :readOnly="readOnly" v-show="currentView === 'sign'" :rowData="rowData"
                :searchObj="searchObj" @handleClose="handleClose" @refreshList="refreshList" @getTotalData="totalData = $event"></sign-in-details>
            <UserSignDetail  v-show="currentView === 'userSign'" :totalData="totalData"></UserSignDetail>
        </div>
        <span slot="footer">
            <slot name="footer-btn"></slot>
        </span>
    </el-dialog>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import DeliveryDetails from './DeliveryDetails';
import SignInDetails from './SignInDetails';
import UserSignDetail from './UserSignDetail';
export default {
    components: { DeliveryDetails, SignInDetails, UserSignDetail },
    computed: {
        netDetailsIsShow: function () {
            return function() {
                return this.rowData.distributionLastFlag === 'Y' &&
                    this.rowData.deliveryType === 'NET' && ['PO', 'DO','AO'].includes(this.rowData.orderType) &&
                    this.rowData.sourceSystem !== 'CAINIAO';
            };
        }
    },
    props: {
        readOnly: { // 这个属性是给回单反查使用的
            type: Boolean,
            default: false
        },
        detailsShow: {
            type: Boolean,
            default: false
        },
        searchObj: {
            type: Object,
            default() {
                return {};
            }
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        },
        titleName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            currentView: 'sign',
            totalData: {}
        };
    },
    methods: {
        handleClose() {
            this.$emit('detailsClose');
        },
        detailsClose() {
            this.$emit('detailsClose');
        },
        handleChangeView(component) {
            this.currentView = component;
        },
        refreshList(searchObj) {
            this.$emit('refreshList', searchObj);
        }
    }
};
</script>
<style lang="less">
    .sign-detail {
        & > .el-dialog {
            min-width: 1220px;
        }
        // top: -50px;
        .el-dialog__header {
            border-bottom: 1px solid #e6e6e6;
            padding-bottom: 0;
        }
        .el-dialog__footer {
            padding: 0;
        }
        .el-dialog__body {
            .footer-btn {
                margin-top: 15px;
                text-align: right;
            }
        }
        .header-title {
            margin-bottom: 10px;
            span {
                cursor: pointer;
                padding-bottom: 10px;
            }
            span:nth-child(2) {
                margin: 0 15px;
            }
        }
        .form-info {
            .el-row {
                margin: 0 0 15px 0;
            }
        }
        .activeClass {
            color: #00bcbf;
            border-bottom: 2px solid #00bcbf;
        }
    }
</style>
